//removeIf(production)
import ClaroluzTopGas from "./claroluz-top-gas";
//removeIf(production)
import FloatWithTwoDecimals from "./float-with-two-decimals";
//endRemoveIf(production)

class ClaroluzBill {
    public cups: string;
    public amount: number;
    public is2TD: boolean;
    public isPeninsula: boolean;
    public topGas: ClaroluzTopGas;
    public yearlySave: number;
    
    constructor({ cups, amount, is2TD, isPeninsula, topGas, yearlySave }: { cups: string; amount: number; is2TD: boolean; isPeninsula: boolean; topGas: ClaroluzTopGas; yearlySave: number; }) {
        this.cups = cups;
        this.amount = new FloatWithTwoDecimals(amount).value;
        this.is2TD = is2TD;
        this.isPeninsula = isPeninsula;
        this.topGas = topGas;
        this.yearlySave = new FloatWithTwoDecimals(yearlySave).value;
    }
}

//removeIf(production)
export default ClaroluzBill;
//endRemoveIf(production)